import React, { useState, useEffect } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Images from "../Images";
import { Col, Container, Row, Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "../Actions/commonFunction";
import {
  setAnserDetails,
  setAnswer,
  setCoinDetail,
} from "../Redux/user.action";
import {
  answerSave,
  getAnswer,
  getCoinDetailAxios,
  getNetwork,
  userAnswerEdit,
} from "../Actions/v1/user";
import { toast } from "react-toastify";

function Vacverification() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [vacstep, setVacstep] = useState(2);
  const dd = useSelector((state) => state.user);
  console.log("🚀 ~ Vacverification ~ dd:", dd);
  const {
    account,
    question,
    questiondetails,
    answer: { answer, totalscore, status, assetname, address },
    answerdetails,
    coinDetail,
  } = useSelector((state) => state.user);
  console.log("🚀 ~ Vacverification ~ coinDetail:", coinDetail);
  console.log("🚀 ~ Vacverification ~ question:", question);
  const [userAnswer, setUserAnswer] = useState({});
  console.log("🚀 ~ Vacverification ~ userAnswer:", userAnswer);
  const [tokenAddress, setTokenAddress] = useState("");
  const [assetName, setAssetName] = useState("");
  const [mapquestion, setMapquestion] = useState({});
  const [networklist, setNetworkList] = useState([]);
  const [selNetwork, setSelNetwork] = useState({});
  const [coinData, setCoinData] = useState({});
  console.log("🚀 ~ Vacverification ~ mapquestion:", mapquestion);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [vacstep]);

  useEffect(() => {
    if (!isEmpty(answer)) {
      setUserAnswer({ ...answer });
      setAssetName(assetname);
      setTokenAddress(address);
    }
  }, [answer]);

  const getNetworklist = async () => {
    let resp = await getNetwork();
    if (resp?.status) {
      setNetworkList(resp.data);
    }
  };

  useEffect(() => {
    if (!isEmpty(question?.question)) {
      let data = {};
      data[`${Object.keys(question?.question)?.[vacstep - 2]}`] =
        question?.question?.[
          `${Object.keys(question?.question)?.[vacstep - 2]}`
        ];
      setMapquestion(data);
    }
  }, [vacstep, question]);

  const onchange = (keyname, value, index) => {
    let data = userAnswer;
    if (data[keyname]) {
      let checkArr = [...data[keyname]];
      checkArr[index] = value;
      data[keyname] = checkArr;
    } else {
      data[keyname] = [];
      data[keyname][index] = value;
    }
    setUserAnswer({ ...data });
  };

  const onNavigate = (data) => {
    dispatch(setAnswer({ answer: data?.answer, totalscore: data?.totalscore }));
    navigate("/vac-scorecard");
  };

  const validate = async () => {
    let err = {},
      questioncount = 0,
      answercount = 0;
    if (isEmpty(userAnswer)) {
      err.userAnswer = "Plase Fill Answers";
    }
    // if (isEmpty(assetName)) {
    //   err.userAnswer = "AssetName Required";
    // }
    // if (isEmpty(tokenAddress)) {
    //   err.userAnswer = "TokenAddress Required";
    // }
    await Promise.all(
      Object.values(question?.question)?.map((val) => {
        questioncount += val.length;
      })
    );
    await Promise.all(
      Object.values(userAnswer)?.map((val) => {
        answercount += val.filter((data) => data != "").length;
      })
    );
    if (questioncount != answercount) {
      err.userAnswer = "Please fill all Answer";
    }
    return err;
  };

  const getAnswerDetail = async () => {
    let answer = await getAnswer({
      userId: account?._id,
    });
    console.log("🚀 ~ checkCookie ~ answer:", answer);
    dispatch(
      setAnswer({
        answer: answer?.data?.[0]?.answer,
        totalscore: answer?.data?.[0]?.totalscore,
        status: answer?.data?.[0]?.status,
        assetname: answer?.data?.[0]?.assetname,
        address: answer?.data?.[0]?.address,
      })
    );
    dispatch(setAnserDetails(answer?.data[0]));
    setAssetName(answer?.data?.[0]?.assetname);
    setTokenAddress(answer?.data?.[0]?.address);
  };

  const saveAnswer = async (istrue) => {
    console.log("userAnswer-->", userAnswer);
    let err = await validate();
    console.log("🚀 ~ saveAnswer ~ err:", err);
    if (!isEmpty(err)) {
      return toast.error(err.userAnswer);
    }
    let resp;
    if (answerdetails?._id) {
      resp = await userAnswerEdit({
        _id: answerdetails?._id,
        userId: account?._id,
        answer: userAnswer,
        assetname: assetName,
        address: tokenAddress,
        status: !istrue ? "completed" : "pending",
      });
    } else {
      resp = await answerSave({
        answer: userAnswer,
        userId: account?._id,
        questionId: questiondetails?._id,
        assetname: assetName,
        address: tokenAddress,
        status: !istrue ? "completed" : "pending",
      });
    }
    if (!istrue) {
      console.log("🚀 ~ saveAnswer ~ resp?.data:", resp?.data);
      onNavigate(resp?.data);
    } else {
      getAnswerDetail();
      setVacstep(vacstep + 1);
    }
  };

  const getCoinDetails = async () => {
    let id = toast.loading("Data Fetching...");
    let resp = await getCoinDetailAxios({
      networkId: selNetwork?.value,
      tokenAddress,
    });

    console.log("🚀 ~ getCoinDetails ~ resp:", resp);
    if (resp?.status) {
      setCoinData(resp?.data);
      setAssetName(resp?.data?.name);
      console.log("{ ...resp?.data, tokenAddress, ...selNetwork }-->", {
        ...resp?.data,
        tokenAddress,
        ...selNetwork,
      });
      dispatch(setCoinDetail({ ...resp?.data, tokenAddress, ...selNetwork }));
      toast.update(id, {
        render: resp?.message,
        autoClose: 1000,
        isLoading: false,
        type: "success",
      });
    } else {
      toast.update(id, {
        render: resp?.message,
        autoClose: 1000,
        isLoading: false,
        type: "error",
      });
    }
  };

  useEffect(() => {
    if (!isEmpty(selNetwork) && !isEmpty(tokenAddress)) {
      getCoinDetails();
    }
  }, [selNetwork, tokenAddress]);

  useEffect(() => {
    getNetworklist();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (isEmpty(account)) {
        toast.warn("Please Login");
        navigate("/");
      }
    }, 2000);
  }, [account]);
  return (
    <div>
      <div>
        <Header />
        <div className="inner_page position-relative pb-5">
          <img src={Images.a1logo} className="elogo" alt="elogo" />
          <img
            src={Images.smallround}
            className="smallround_footer"
            alt="round"
          />
          <Container className="mt-5">
            <div className="vac_border position-relative rounded-3 py-5 px-2 px-sm-4">
              <img src={Images.a1logo} className="a1logo" alt="round" />
              <img src={Images.a2logo} className="a2logo" alt="elogo" />
              <img src={Images.a2logo} className="a3logo" alt="elogo" />
              <Row>
                <Col
                  xl={vacstep === 1 ? 6 : 7}
                  className="mx-auto position-relative"
                >
                  <img
                    src={Images.smallround}
                    className="bot_round"
                    alt="round"
                  />

                  <div className="vac_border rounded-4 py-4 px-4">
                    {/* {vacstep === 1 && (
                      <>
                        <h4 className="text-center">Begin Verification</h4>
                        <p className="text-center">
                          Fields marked with an asterisk <span className="redclr">(*)</span>  are required.
                        </p>
                        <div className="mb-3">
                          <label className="mb-2">Select Network</label>
                          <Dropdown
                            className="reqdrop"
                            onSelect={(e) => {
                              setSelNetwork({
                                value: e.split(",")[0],
                                data: e.split(",")[1],
                              });
                            }}
                          >
                            <Dropdown.Toggle
                              className="w-100 text-start themeclr fw-500"
                              variant="success"
                              id="dropdown-basic"
                            >
                              {isEmpty(selNetwork)
                                ? "Select Network"
                                : selNetwork?.data}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="w-100">
                              {networklist?.map((val) => (
                                <Dropdown.Item
                                  eventKey={`${val?._id},${val.name}`}
                                >
                                  {val?.name}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div>
                          <label className="mb-2">
                            Paste Contract Address:{" "}
                            <span className="redclr">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control verifi_input themeclr fw-500"
                            onChange={(e) => setTokenAddress(e.target.value)}
                            value={tokenAddress}
                          />
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="mb-2">
                            Symbol Of Your Token Based On Contract Address
                          </label>
                          <input
                            type="text"
                            className="form-control verifi_input themeclr"
                            disabled={true}
                            value={assetName}
                          />
                        </div>
                       
                        <div className="text-center">
                          <button
                            className="themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4"
                            onClick={() => setVacstep(2)}
                            disabled={isEmpty(coinData)}
                          >
                            Continue
                          </button>
                        </div>
                      </>
                    )} */}

                    {vacstep > 1 && vacstep !== 100 && (
                      <>
                        {!isEmpty(mapquestion) &&
                          Object.keys(mapquestion)?.map((val, i) => (
                            <>
                              <h4 className="text-center fw-600 pb-3">
                               Edaface Academy SOC Item {vacstep - 1}:{" "}
                                {val}
                              </h4>
                              {mapquestion[val]?.length > 0 &&
                                mapquestion[val]?.map((item, ind) => (
                                  <div className="mt-4">
                                    <p className="que mb-2 quefont">Evaluative Question {ind+1}:{" "}{item?.question}</p>
                                    <p className="mt-2 mb-3 themeclr desfont">
                                      ({item?.description})
                                    </p>
                                    <div className="d-flex gap-4">
                                      <div class="form-check">
                                        <label
                                          class="form-check-label"
                                          for="flexCheckDefault"
                                        >
                                          Yes
                                        </label>
                                        <input
                                          class="form-check-input"
                                          type="checkbox"
                                          checked={
                                            userAnswer[val]?.[ind] == "yes"
                                          }
                                          onChange={() =>
                                            onchange(val, "yes", ind)
                                          }
                                          id="flexCheckDefault"
                                        />
                                      </div>
                                      <div class="form-check">
                                        <label
                                          class="form-check-label"
                                          for="flexCheckDefault"
                                        >
                                          No
                                        </label>
                                        <input
                                          class="form-check-input"
                                          type="checkbox"
                                          value=""
                                          checked={
                                            userAnswer[val]?.[ind] == "no"
                                          }
                                          onChange={() =>
                                            onchange(val, "no", ind)
                                          }
                                          id="flexCheckDefault"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              <div className="d-block d-sm-flex widthnone justify-content-between">
                                {vacstep > 1 && (
                                  <div className="text-start">
                                    <button
                                      className="themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4"
                                      onClick={() => setVacstep(vacstep - 1)}
                                    >
                                      Previous Page
                                    </button>
                                  </div>
                                )}
                                <div className="text-start text-sm-end">
                                  {/* <button
                                    className="themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4 me-2"
                                    onClick={() =>
                                      saveAnswer(
                                        !isEmpty(
                                          Object.keys(question?.question)?.[
                                            vacstep - 1
                                          ]
                                        )
                                      )
                                    }
                                  >
                                    {!isEmpty(question?.question) &&
                                    !isEmpty(
                                      Object.keys(question?.question)?.[
                                        vacstep - 1
                                      ]
                                    )
                                      ? "Save As Draft"
                                      : "Save"}
                                  </button> */}
                                  <button
                                    className="themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4"
                                    onClick={() => {
                                      if (
                                        !isEmpty(question?.question) &&
                                        !isEmpty(
                                          Object.keys(question?.question)?.[
                                            vacstep - 1
                                          ]
                                        )
                                      ) {
                                        setVacstep(
                                          !isEmpty(question?.question) &&
                                            !isEmpty(
                                              Object.keys(question?.question)?.[
                                                vacstep - 1
                                              ]
                                            )
                                            ? vacstep + 1
                                            : vacstep - 1
                                        );
                                      } else {
                                        saveAnswer(
                                          !isEmpty(
                                            Object.keys(question?.question)?.[
                                              vacstep - 1
                                            ]
                                          )
                                        );
                                      }
                                    }}
                                  >
                                    {!isEmpty(question?.question) &&
                                    !isEmpty(
                                      Object.keys(question?.question)?.[
                                        vacstep - 1
                                      ]
                                    )
                                      ? "Next Page"
                                      : "Save"}
                                  </button>
                                </div>
                              </div>

                              {/* <div className="text-end">
                                <button
                                  className="themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4"
                                  onClick={() =>
                                    setVacstep(
                                      !isEmpty(question?.question) &&
                                        !isEmpty(
                                          Object.keys(question?.question)?.[
                                            vacstep - 1
                                          ]
                                        )
                                        ? vacstep + 1
                                        : vacstep - 1
                                    )
                                  }
                                >
                                  {!isEmpty(question?.question) &&
                                  !isEmpty(
                                    Object.keys(question?.question)?.[
                                      vacstep - 1
                                    ]
                                  )
                                    ? "Next Page"
                                    : "Previous Page"}
                                </button>
                              </div> */}
                            </>
                          ))}
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Vacverification;
